/* global angular */

var ngModule = angular.module('trends');

ngModule.service('FooterDisplayHelper',['$rootScope', function($rootScope) {
    var displayFooter = true;
    this.setDisplayFooter = function(value) {
        displayFooter = value;
    };
    this.getDisplayFooter = function() {
        return displayFooter;
    };

    $rootScope.$on('$stateChangeStart', function() { displayFooter = true; });
}]).directive('footer', ['FooterDisplayHelper',
    function(FooterDisplayHelper) {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, element) {
                scope.$watch(FooterDisplayHelper.getDisplayFooter, function(new_val) {
                    if (new_val) {
                        element.show();
                    }
                    else {
                        element.hide();
                    }
                }, true);
            }
        };
    }
]).directive('homepageFooterStatus', ['FooterDisplayHelper','$rootScope',
    function(FooterDisplayHelper, $rootScope) {
        return {
            restrict: 'A',
            scope: { selectedTab: '&homepageFooterStatus'  },
            link: function(scope) {
                var loadStates = {
                    'trend': false,
                    'observation': false,
                    'group': true
                };

                $rootScope.$on('contentListLoaded', function(ev, category) {
                    loadStates[category] = true;
                    updateFooterStatus();
                });

                var updateFooterStatus = function() {
                    var state = loadStates[scope.selectedTab()];
                    if (state === undefined) {
                        state = true;
                    }

                    FooterDisplayHelper.setDisplayFooter(state);
                };

                scope.$watch('selectedTab()', updateFooterStatus);
            }
       };
    }
]);
